import React, { useState } from "react";
 
const DriverPage = () => {
  const [view, setView] = useState("weekly");
  const [checklistData, setChecklistData] = useState(null);
 
  const goToWeekly = () => setView("weekly");
  const goToDaily = () => setView("daily");
 
  const showChecklist = (dayData) => {
    setChecklistData(dayData);
    setView("checklist");
  };
 
  return (
    <div style={styles.appContainer}>
      {/* Header */}
      <div style={styles.header}>
        <button style={styles.icon}>✖</button>
        <select style={styles.dropdown}>
          <option>Local Driver</option>
          <option>ROYAL MAIL</option>
          <option>UPS COURIER</option>
        </select>
        <button
          style={styles.icon}
          onClick={view === "daily" ? goToWeekly : goToDaily}
        >
          📅
        </button>
      </div>
 
      {/* Views */}
      {view === "daily" && <DailyView />}
      {view === "weekly" && <WeeklyView showChecklist={showChecklist} />}
      {view === "checklist" && checklistData && (
        <PrepChecklistView data={checklistData} goBack={() => setView("weekly")} />
      )}
    </div>
  );
};
 
const DailyView = () => (
  <div style={styles.content}>
    <h2 style={styles.heading}>Daily View</h2>
    <p style={styles.date}>Fri Apr 25 2025</p>
    <button style={styles.checklistBtn}>
      Prep. Checklist
      <div style={styles.subText}>No deliveries & No pickups</div>
    </button>
  </div>
);
 
const WeeklyView = ({ showChecklist }) => {
  const weeks = [
    {
      range: "May 4th 2024 - May 10th 2024",
      days: [
        { day: "Saturday", date: "May 4th, 2024" },
        { day: "Sunday", date: "May 5th, 2024" },
        { day: "Monday", date: "May 6th, 2024", deliveries: [1, 2] },
        { day: "Tuesday", date: "May 7th, 2024", deliveries: [25, 25], pickups: [1, 1] },
        { day: "Wednesday", date: "May 8th, 2024", deliveries: [13, 13], pickups: [1, 3] },
        { day: "Thursday", date: "May 9th, 2024", deliveries: [11, 12] },
        { day: "Friday", date: "May 10th, 2024", deliveries: [9, 9], pickups: [1, 1] },
      ],
    },
    {
      range: "May 11th 2024 - May 17th 2024",
      days: [
        { day: "Saturday", date: "May 11th, 2024" },
        { day: "Sunday", date: "May 12th, 2024" },
        { day: "Monday", date: "May 13th, 2024", deliveries: [2, 3], pickups: [1, 2] },
        { day: "Tuesday", date: "May 14th, 2024", deliveries: [3, 3] },
        { day: "Wednesday", date: "May 15th, 2024", pickups: [1, 1] },
        { day: "Thursday", date: "May 16th, 2024" },
        { day: "Friday", date: "May 17th, 2024", deliveries: [0, 1] },
      ],
    },
    {
      range: "May 17th 2024 - May 24th 2024",
      days: [
        { day: "Saturday", date: "May 4th, 2024" },
        { day: "Sunday", date: "May 5th, 2024" },
        { day: "Monday", date: "May 6th, 2024", deliveries: [1, 2] },
        { day: "Tuesday", date: "May 7th, 2024", deliveries: [25, 25], pickups: [1, 1] },
        { day: "Wednesday", date: "May 8th, 2024", deliveries: [13, 13], pickups: [1, 3] },
        { day: "Thursday", date: "May 9th, 2024", deliveries: [11, 12] },
        { day: "Friday", date: "May 10th, 2024", deliveries: [9, 9], pickups: [1, 1] },
      ],
    },
    {
      range: "May 25th 2024 - May 31th 2024",
      days: [
        { day: "Saturday", date: "May 11th, 2024" },
        { day: "Sunday", date: "May 12th, 2024" },
        { day: "Monday", date: "May 13th, 2024", deliveries: [2, 3], pickups: [1, 2] },
        { day: "Tuesday", date: "May 14th, 2024", deliveries: [3, 3] },
        { day: "Wednesday", date: "May 15th, 2024", pickups: [1, 1] },
        { day: "Thursday", date: "May 16th, 2024" },
        { day: "Friday", date: "May 17th, 2024", deliveries: [0, 1] },
      ],
    },
  ];
 
  const [weekIndex, setWeekIndex] = useState(0);
  const [selectedDay, setSelectedDay] = useState(null);
 
  const currentWeek = weeks[weekIndex];
 
  const isComplete = (count) => count?.[0] === count?.[1];
 
  const handleDayClick = (index) => {
    setSelectedDay(selectedDay === index ? null : index);
  };
 
  const goToPrevWeek = () => setWeekIndex((prev) => Math.max(0, prev - 1));
  const goToNextWeek = () => setWeekIndex((prev) => Math.min(weeks.length - 1, prev + 1));
 
  return (
    <div style={styles.content}>
      <h2 style={styles.heading}>Weekly View</h2>
      <p style={styles.subheading}>{currentWeek.range}</p>
 
      <div style={styles.navContainer}>
        <button
          style={{
            ...styles.navBtn,
            ...(weekIndex === 0 ? styles.navBtnDisabled : {}),
          }}
          onClick={goToPrevWeek}
          disabled={weekIndex === 0}
        >
          &lt;
        </button>
        <button
          style={{
            ...styles.navBtn,
            ...(weekIndex === weeks.length - 1 ? styles.navBtnDisabled : {}),
          }}
          onClick={goToNextWeek}
          disabled={weekIndex === weeks.length - 1}
        >
          &gt;
        </button>
      </div>
 
      <div style={styles.weekList}>
        {currentWeek.days.map((item, index) => {
          const deliveryComplete = isComplete(item.deliveries);
          const pickupComplete = item.pickups ? isComplete(item.pickups) : true;
 
          let bgColor = "#fff";
          if (item.deliveries || item.pickups) {
            bgColor = deliveryComplete && pickupComplete ? "#d4edc9" : "#ffe4b5";
          }
 
          return (
            <div
              key={index}
              style={{ ...styles.dayRow, backgroundColor: bgColor }}
              onClick={() => handleDayClick(index)}
            >
              <div>
                <strong>{item.day}, {item.date}</strong>
              </div>
              <div style={styles.details}>
                {item.deliveries && (
                  <div>Deliveries: {item.deliveries[0]}/{item.deliveries[1]}</div>
                )}
                {item.pickups && (
                  <div>Pickups: {item.pickups[0]}/{item.pickups[1]}</div>
                )}
              </div>
 
              {selectedDay === index && (
                <button
                  style={styles.checklistBtn}
                  onClick={(e) => {
                    e.stopPropagation();
                    showChecklist(item);
                  }}
                >
                  View Orders
                  <div style={styles.subText}>
                    {item.deliveries && `Deliveries: ${item.deliveries.join(", ")}`}<br />
                    {item.pickups && `Pickups: ${item.pickups.join(", ")}`}
                  </div>
                </button>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
};
 
const PrepChecklistView = ({ data, goBack }) => (
  <div style={styles.content}>
    <h2 style={styles.heading}>Prep Checklist</h2>
    <p style={styles.date}>{data.day}, {data.date}</p>
 
    <div style={styles.checklistContainer}>
      {data.deliveries ? (
        <div style={styles.checklistBox}>
          <strong>Deliveries:</strong>
          <p>{data.deliveries[0]} of {data.deliveries[1]} completed</p>
        </div>
      ) : (
        <div style={styles.checklistBox}><em>No deliveries</em></div>
      )}
 
      {data.pickups ? (
        <div style={styles.checklistBox}>
          <strong>Pickups:</strong>
          <p>{data.pickups[0]} of {data.pickups[1]} completed</p>
        </div>
      ) : (
        <div style={styles.checklistBox}><em>No pickups</em></div>
      )}
    </div>
 
    <button style={styles.navBtn} onClick={goBack}>← Back to Weekly</button>
  </div>
);
 
// Updated Styles (CSS-in-JS)
const styles = {
  appContainer: {
    fontFamily: "Arial, sans-serif",
  },
  header: {
    backgroundColor: "#004aad",
    padding: "10px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  icon: {
    background: "transparent",
    border: "none",
    fontSize: "24px",
    cursor: "pointer",
    color: "white",
  },
  dropdown: {
    flex: 1,
    margin: "0 10px",
    padding: "5px",
    fontSize: "16px",
    borderRadius: "5px",
  },
  content: {
    padding: "20px",
    textAlign: "center",
  },
  heading: {
    margin: "0 0 10px",
    fontSize: "24px",
    fontWeight: "bold",
    color: "#004aad",
  },
  subheading: {
    color: "#555",
    fontSize: "14px",
  },
  date: {
    color: "#555",
    marginBottom: "20px",
  },
  checklistBtn: {
    backgroundColor: "#004aad",
    color: "white",
    border: "none",
    padding: "15px 20px",
    fontSize: "16px",
    borderRadius: "5px",
    cursor: "pointer",
  },
  subText: {
    fontSize: "12px",
    marginTop: "5px",
  },
  navContainer: {
    display: "flex",
    justifyContent: "space-around",
    margin: "20px",
  },
  navBtn: {
    backgroundColor: "#004aad",
    color: "white",
    padding: "15px 30px",
    border: "none",
    borderRadius: "10px",
    fontSize: "18px",
    cursor: "pointer",
  },
  navBtnDisabled: {
    backgroundColor: "#ccc",
    cursor: "not-allowed",
  },
  weekList: {
    padding: "0 20px",
    marginTop: "20px",
  },
  dayRow: {
    margin: "10px 0",
    padding: "15px 20px",
    textAlign: "left",
    fontSize: "16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderRadius: "8px",
    cursor: "pointer",
  },
  details: {
    textAlign: "right",
    fontSize: "14px",
    color: "#333",
  },
  checklistContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "20px",
    margin: "20px 0",
  },
  checklistBox: {
    backgroundColor: "#f4f4f4",
    padding: "20px",
    borderRadius: "10px",
    width: "80%",
    textAlign: "left",
    boxShadow: "0 2px 5px rgba(0, 0, 0, 0.1)",
  },
};
 
export default DriverPage;
 
 